import script from "./KitchenServingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./KitchenServingView.vue?vue&type=script&lang=ts&setup=true"

import "./KitchenServingView.vue?vue&type=style&index=0&id=4176210a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_typescript@5.8.3__webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4176210a"]])

export default __exports__